var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      directives: [
        {
          name: "show",
          rawName: "v-show",
          value: !_vm.isHidden,
          expression: "!isHidden"
        }
      ],
      staticClass: "betType RoundRobin betType-RR",
      class: [
        _vm.statusToConfirm ? "statusToConfirm-" + _vm.statusToConfirm : ""
      ]
    },
    [
      [
        _c("div", { staticClass: "header-RR rr_title" }, [
          _c("div", { staticClass: "betType_header_title" }, [
            _c("span", { key: "rr_first", staticClass: "rr_first" }, [
              _vm._v(_vm._s(_vm.$t("BetSlip.betType.RR." + _vm.id)))
            ]),
            _vm._v(" "),
            _c("span", { staticClass: "xWagers" }, [
              _vm._v(
                "\n\t           x " +
                  _vm._s(_vm.allowedBetTypesAndReturns.UnitCount) +
                  "\n\t          "
              ),
              _c("span", [
                _vm._v(_vm._s(_vm.$t("BetSlip.tab.RR.betType.wagers")))
              ])
            ]),
            _vm._v(" "),
            _vm.isForBB
              ? _c(
                  "span",
                  { staticClass: "isForBB float-right" },
                  [
                    _vm.isForBB
                      ? _c("icon", {
                          attrs: { name: "icon-available-for-bb-white" }
                        })
                      : _vm._e()
                  ],
                  1
                )
              : _vm._e(),
            _vm._v(" "),
            _vm.statusToConfirm
              ? _c("span", { staticClass: "statusToConfirm" }, [
                  _vm._v(
                    _vm._s(
                      _vm.$t("BetSlip.placement.bet." + _vm.statusToConfirm)
                    )
                  )
                ])
              : _vm._e()
          ]),
          _vm._v(" "),
          _vm.betslipLayout2
            ? _c("div", { staticClass: "price_div" }, [
                _c("span", { staticClass: "price" }, [
                  _vm._v(
                    "\n            " +
                      _vm._s(_vm.formattedOdds) +
                      "\n          "
                  )
                ])
              ])
            : _vm._e()
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "bet_content" }, [
          !_vm.betslipLayout2
            ? _c("div", { staticClass: "odds_div" }, [
                _c("span", { staticClass: "price_title" }, [
                  _vm._v(_vm._s(_vm.$t("BetSlip.oddsprice")))
                ]),
                _vm._v(" "),
                _c("span", { staticClass: "price" }, [
                  _vm._v(
                    "\n            " +
                      _vm._s(_vm.formattedOdds) +
                      "\n          "
                  )
                ])
              ])
            : _vm._e(),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "stake-n-return" },
            [
              _c("stake-and-return", {
                staticClass: "clear-both",
                attrs: {
                  id: _vm.id,
                  perType: "PerBetType",
                  tab: _vm.tab,
                  currentBetSlipState: _vm.currentBetSlipState,
                  allowedBetTypesAndReturns: _vm.allowedBetTypesAndReturns,
                  statusToConfirm: _vm.statusToConfirm
                },
                on: { hideBetType: _vm.hideBetType }
              })
            ],
            1
          )
        ])
      ]
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-adc0fd54", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-adc0fd54","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/sports/betslipV2/betTypes/betTypeRR.vue
// module id = null
// module chunks = 